import { axiosApi,uploadApi } from './api';

export const GetDeviceTypes = (projectId) => axiosApi('get', '/device/type/all')({projectId: projectId});

export const GetDevicesTree = (projectId) => axiosApi('get', '/device/project/all')({projectId: projectId});

export const GetLoopForDevice = (deviceId) => axiosApi('get', '/loop/list')({deviceId: deviceId});

export const GetDeviceForName = (projectId, name) => axiosApi('get', '/device/name')({projectId: projectId, name: name});

export const GetFileAndFolder = (projectId) => axiosApi('get', '/file/list')({projectId: projectId});

export const GetWireByDeviceID = (deviceId) => axiosApi('get', '/device/details')({deviceId: deviceId});

// 创建文件夹
export const AddFolder = (projectId,name) => axiosApi('post', '/file/create')({projectId: projectId, name: name});

// 重命名文件夹
export const ModifyFolder = (projectId, path, newName) => axiosApi('put', '/file/rename')({projectId: projectId, path: path, newName: newName});

// 删除文件夹和文件(以/开头)
export const DeleteF = (projectId, name) => axiosApi('delete', '/file/del')({projectId: projectId, name: name});

// 上传文件
export const UploadFile = (projectId, folder, file) => {
    let data = new FormData()
    data.append("file", file)
    data.append("projectId", projectId)
    data.append("path", folder)
    return uploadApi("/upload/file")(data)
}

// 下载文件
export const DownloadFile = (projectId, path) => axiosApi('get', '/file/download')({projectId: projectId, path: path});